import Snowfall from 'react-snowfall';

/**
 * Seasonal Effects Component
 * 
 * TEMPORARY COMPONENT - Easy removal instructions:
 * 1. Delete this file (src/components/SeasonalEffects.tsx)
 * 2. Remove import and usage from src/App.tsx
 * 3. Run: npm uninstall react-snowfall
 */

const SeasonalEffects = () => {
  // Only show during December (month index 11)
  const currentMonth = new Date().getMonth();
  const isChristmasSeason = currentMonth === 11; // December

  if (!isChristmasSeason) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 z-50 pointer-events-none"
      aria-hidden="true"
    >
      <Snowfall
        snowflakeCount={100}
        speed={[0.5, 1.5]}
        wind={[-0.5, 1]}
        radius={[0.5, 2.5]}
        color="rgba(255, 255, 255, 0.8)"
      />
    </div>
  );
};

export default SeasonalEffects;
